import {fetchGet, fetchPost} from '@/fetch/api'

const base = '/device/web/assistant'
const quiet = {skipGlobalErrorMessage: true, timeout: 15000}

export const createAssistantSession = data => fetchPost(`${base}/session/create`, data, true, quiet)
export const listAssistantSessions = () => fetchGet(`${base}/session/list`, {}, false, quiet)
export const getAssistantHistory = sessionId => fetchGet(`${base}/history`, {sessionId}, false, quiet)
export const sendAssistantMessage = data => fetchPost(`${base}/send`, data, true, quiet)
export const getAssistantReply = taskId => fetchGet(`${base}/reply`, {taskId}, false, quiet)

export const assistantData = response => response && response.data !== undefined ? response.data : response
